import { useGetApiV1ClassroomdisciplineSharedClassModules } from '@/shared/api/generated';
import { mapDropdownOptions, useDebouncedFilter } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Busca de módulos de aula por texto (debounce + mínimo de 3 caracteres) para o
 * autocomplete de módulo. Consome o lookup `shared/class-modules` do Kubb.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @param courseId - Curso selecionado, para escopar a busca (`CourseId`), ou `null`.
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useClassModuleSearchDropdown(filter = '', courseId: number | null = null) {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedClassModules(
    isReady
      ? { Search: debouncedFilter, ...(courseId !== null ? { CourseId: courseId } : {}) }
      : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
